import { yupLocalized } from "@ryde/shared";

export interface IImportBusStationsForm {
  busStationsIds: number[];
  isCreateMissingAreas: boolean;
}

export const importBusStationsValidationSchema = {
  busStationsIds: yupLocalized
    .array()
    .min(1)
    .of(yupLocalized.number().required()),
  isCreateMissingAreas: yupLocalized.boolean(),
};
